module.exports = __webpack_public_path__ + "img/icon(6).06258b1d.png";